import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  AdHocModalComponent, type AdHocModalProps,
} from './adHocModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    AdHoc: AdHocModalProps;
  }
}

modalRenderer.register('AdHoc', AdHocModalComponent);
